import React from "react";
import Report from "../components/Report";
import Table from "../../../components/TableX";
import Typography from "@material-ui/core/Typography";
import { useLazyQuery, API } from "../../../api";
import * as dateFns from "date-fns";

export default function GRNDetails() {
  const [getReport, { data, loading }] = useLazyQuery(API.GET_GRN_DETAILS, {
    fetchPolicy: "network-only",
  });

  const [filters, setFilters] = React.useState({
    startDate: dateFns.startOfMonth(new Date()),
    endDate: dateFns.endOfMonth(new Date()),
  });

  React.useEffect(() => {
    getReport({ data: filters });
    // eslint-disable-next-line
  }, [filters]);

  const onDateRangeChange = ({ startDate, endDate }) => {
    setFilters({ ...filters, startDate, endDate });
  };

  const getStatus = (row) => {
    const { netTotal, dueAmount } = row;
    let value = "Unpaid";
    if (dueAmount > 0.01 && dueAmount < netTotal) {
      value = "Partial";
    } else if (dueAmount < 0.01) {
      value = "Paid";
    }
    if (netTotal < 0.01) {
      value = "Returned";
    }
    return value;
  };

  const renderStatus = (value) => {
    let color = "#EE4123";
    if (value === "Partial") {
      color = "#FAAD14";
    } else if (value === "Paid") {
      color = "#4CAF50";
    }
    if (value === "Returned") {
      color = "#999999";
    }
    return (
      <Typography style={{ color, fontSize: 13 }} variant="button">
        {value.toUpperCase()}
      </Typography>
    );
  };

  const getData = () => {
    if (!data) return [];
    return data.map((t) => ({ ...t, status: getStatus(t) }));
  };

  const columns = [
    {
      name: "date",
      label: "GRN Date",
      options: { align: "center", date: true },
    },
    {
      name: "grnNo",
      label: "GRN #",
      options: { align: "center" },
    },
    {
      name: "supplier.name",
      label: "Supplier Name",
      options: { align: "left", width: 400 },
    },
    {
      name: "netTotal",
      label: "Total",
      options: { align: "right", money: true, showTotal: true },
    },
    {
      name: "dueAmount",
      label: "Balance",
      options: { align: "right", money: true, showTotal: true },
    },
    {
      name: "status",
      label: "Status",
      options: {
        align: "center",
        customBodyRender: (v) => renderStatus(v),
      },
    },
  ];

  return (
    <Report
      title="GRN Details"
      useDateRange
      onDateRangeChange={onDateRangeChange}
      startDate={filters?.startDate}
      endDate={filters?.endDate}
      data={getData()}
      columns={columns}
    >
      <Table
        data={getData()}
        columns={columns}
        showTotals
        isLoading={loading}
      />
    </Report>
  );
}
